import { REHYDRATE } from 'redux-persist/constants';
import {
  AUTHORIZED,
  LOGIN_SUCCESS,
  LOGIN_REFRESH,
  LOGIN_FAILURE,
  LOGIN_PROFILE,
  LOGIN_START,
  LOGOUT,
  NO_USER,
  LOGIN_SILENT,
} from '../../actions/constants/types';

const initialAuthState = {
  failure: null,
  success: null,
  loginName: null,
  displayName: null,
  notAuthorized: false,
  isAuthenticated: false,
  isLoadingUser: false,
  isFetching: false,
  jwtToken: null,
  featureAccessList: [],
  defaultOrgUnitId: null,
  orgUnitIds: [],
  isExpired: false,
  clinicianId: [],
  tid: null,
  externalProviderType: null,
};

function auth(state = initialAuthState, action) {
  const { failure = null, success = null } = action;
  switch (action.type) {
    case REHYDRATE: {
      const incoming = action.payload.global ? action.payload.global.auth : null;
      if (incoming) return { ...state, ...initialAuthState, ...incoming };
      return state;
    }
    case NO_USER:
      return {
        ...initialAuthState,
        isExpired: true,
        jwtToken: null,
      };
    case LOGIN_START:
      return {
        ...state,
        failure,
        success,
        isFetching: true,
      };
    case AUTHORIZED:
      return {
        ...state,
        displayName: action.user.name,
        loginName: action.user.email,
        failure,
        success,
        isFetching: true,
      };
    case LOGIN_SILENT:
      return {
        ...state,
        isLoadingUser: true,
      };
    case LOGIN_PROFILE:
      return {
        ...state,
        isFetching: true,
      };
    case LOGIN_REFRESH:
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...initialAuthState,
        displayName: action.response.displayName,
        defaultOrgUnitId: action.response.defaultOrgUnitId,
        orgUnitIds: action.response.orgUnitIds,
        isAuthenticated: true,
        isFetching: false,
        isLoadingUser: false,
        notAuthorized: false,
        jwtToken: action.response.token,
        featureAccessList: action.response.featureAccessList,
        clinicianId: action.response.clinicianId,
        settings: action.response.settings,
        tid: action.response.tid,
        externalProviderType: action.response.externalProviderType,
        tenantCode: action.response.tenantCode,
        failure,
        success,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        ...initialAuthState,
        isFetching: false,
        isLoadingUser: false,
        notAuthorized: true,
        failure: action.message,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialAuthState,
        failure,
        success,
      };
    default:
      return state;
  }
}

export default auth;
